var ActionTypeList = ["deposit", "withdraw", "transfer", "migrate"];
export var ACTIONS = {
    deposit: "deposit",
    withdraw: "withdraw",
    transfer: "transfer",
    migrate: "migrate",
};
export var V2WithdrawOptionList = ["standard", "instant"];
export var STEPS = {
    warningStep: -1,
    formStep: 0,
    previewStep: 1,
    confirmationStep: 2,
    submittedStep: 3,
};
//# sourceMappingURL=types.js.map